import { render } from "./WCSaveForLaterButton.vue?vue&type=template&id=554d2228"
import script from "./WCSaveForLaterButton.vue?vue&type=script&lang=js"
export * from "./WCSaveForLaterButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__